<shared-modal-container
  [headline]="dialogData?.header ?? ''"
  (closeModal)="close()"
  [isDialogPositionUp]="(isDialogPositionUp$ | async) ?? false">
  <div class="bg-light px-4 pb-4 w-100">
    @if (dialogData?.customTemplate != null) {
      <ng-container [ngTemplateOutlet]="dialogData.customTemplate" />
    } @else {
      <div class="text-14 text-center">
        {{ dialogData.text }}
      </div>
    }

    <div class="flex-column p-3 gap-3">
      <button pButton class="m-a p-button p-button-outline centered w-100" (click)="close()">Close</button>
    </div>
  </div>
</shared-modal-container>
